import React from 'react';
import FormField from '../../../components/forms/FormField';
import { FiPlus, FiMinus } from 'react-icons/fi';

export default function InstituicoesGovernanca({ repeatableFields, addRepeatableField, removeRepeatableField }) {
  return (
    <div>
    <div className="mb-6 p-4 bg-blue-50 rounded-lg">
      <p className="text-sm text-blue-700">Esta seção coleta informações sobre instituições e mecanismos de governança relacionados ao desenvolvimento produtivo.</p>
    </div>

    <div className="mt-4">
      <FormField
        name="presenca_conselhos"
        label="Presença de Conselhos Municipais relacionados ao desenvolvimento produtivo"
        type="radio"
        options={[
          { value: 'sim', label: 'Sim' },
          { value: 'nao', label: 'Não' },
        ]}
        helpText="Indique se existem conselhos municipais formalmente constituídos"
      />
    </div>
    
    {/* Campos repetíveis para conselhos */}
    {repeatableFields.conselho.map((item) => (
      <div key={item.id} className="mt-4 p-4 border border-gray-200 rounded-lg">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-md font-medium">Conselho {item.id}</h3>
          {item.id !== 1 && (
            <button 
              type="button" 
              onClick={() => removeRepeatableField('conselho', item.id)}
              className="text-red-500 hover:text-red-700"
            >
              <FiMinus className="mr-1" /> Remover
            </button>
          )}
        </div>
        
        <FormField
          name={`conselho_nome_foco_${item.id}`}
          label="Nome e foco do conselho"
          placeholder="Digite o nome e foco principal do conselho"
          helpText="Preencha apenas se respondeu 'Sim' à questão anterior"
        />
      </div>
    ))}
    
    <div className="mb-4 mt-2">
      <button 
        type="button" 
        onClick={() => addRepeatableField('conselho')}
        className="flex items-center text-blue-600 hover:text-blue-800"
      >
        <FiPlus className="mr-1" /> Adicionar outro conselho
      </button>
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
      <FormField
        name="orcamento_executado"
        label="Orçamento executado (%)"
        type="percent"
        placeholder="Digite a porcentagem"
        helpText="Porcentagem do orçamento municipal executado"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
          max: {
            value: 100,
            message: 'O valor deve ser menor ou igual a 100',
          },
        }}
      />
      
      <FormField
        name="convenios_ativos"
        label="Convênios ativos (número)"
        type="numeric"
        placeholder="Digite o número de convênios"
        helpText="Quantidade de convênios ativos relacionados ao desenvolvimento produtivo"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
        }}
      />
      
      <FormField
        name="principais_areas"
        label="Principais áreas"
        placeholder="Digite as principais áreas"
        helpText="Áreas principais dos convênios ativos"
      />
    </div>
    <hr className="border-t border-gray-300 my-6" />
    <div className="mt-6 space-y-4">
      <FormField
        name="fontes_principais_secao6"
        label="Fontes principais"
        type="textarea"
        placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
        helpText=""
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
      
      <FormField
        name="links_acesso_secao6"
        label="Links de acesso"
        type="textarea"
        placeholder="Insira os links para acesso às fontes"
        helpText="Informe URLs para acesso às fontes quando disponível"
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
    </div>
  </div>
  );
}
